import { render, staticRenderFns } from "./ATEMWidget.vue?vue&type=template&id=f2f2b744&scoped=true"
import script from "./ATEMWidget.vue?vue&type=script&lang=js"
export * from "./ATEMWidget.vue?vue&type=script&lang=js"
import style0 from "./ATEMWidget.vue?vue&type=style&index=0&id=f2f2b744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f2b744",
  null
  
)

export default component.exports